import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { Switch, BrowserRouter, Route } from 'react-router-dom'

import Menu from './components/Menu'
import Footer from './components/Footer'
import Container from './components/Container'

import Home from './pages/Home'
import Contact from './pages/Contact'
import Services from './pages/Services'
import Medlemssystem from './pages/Medlemssystem'
import Employees from './pages/Employees'
import Work from './pages/Work'
// import ThingsWeCareAbout from './pages/ThingsWeCareAbout'
// import Frameworks from './pages/Frameworks'
import 'core-js/es6/symbol'
import 'core-js/es6/array'

import Arbeiderpartiet from './pages/Arbeiderpartiet'
import Clooger from './pages/Clooger'
import Vipps from './pages/Vipps'
import NCL from './pages/NCL'

import RouteChange from './RouteChange'

import './styles/styles.css'

const routes = [
  {
    routeProps: { path: '/', exact: true },
    Component: Home,
    helmetProps: {
      title: 'Appresso',
      description: 'Appresso er et utviklingsfirma som er spesialisert på programmering for Web og API-er',
      keywords: 'Django, Python, PostgreSQL, React, Integrasjon, API, Heroku, Cloud, AWS, SEO, WCAG'
    }
  },
  {
    routeProps: { path: '/tjenester' },
    Component: Services,
    helmetProps: {
      title: 'Appresso - Tjenester',
      description: 'Programmering med Python, Javascript, SQL, cloudløsninger, skyløsninger',
      keywords: 'Programmering, Backend, Frontend, Integrasjon, API, Drift, Cloud'
    }
  },
  {
    routeProps: { path: '/medlemssystem' },
    Component: Medlemssystem,
    helmetProps: {
      title: 'Appresso - Medlemssystem',
      description: 'Appresso tilbyr et moderne og brukervennlig medlemssystem',
      keywords: 'Medlemssystem, medlemsregister, medlemmer, medlem'
    }
  },
  {
    routeProps: { path: '/arbeid', exact: true },
    Component: Work,
    helmetProps: {
      title: 'Appresso - Referanser',
      description: 'Appresso har Vipps, NCL, Universitetet i Oslo, og Arbeiderpartiet blant våre kunder',
      keywords: 'Referanser, vipps, ncl, universitetet i oslo, arbeiderpartiet'
    }
  },
  {
    routeProps: { path: '/arbeid/arbeiderpartiet' },
    Component: Arbeiderpartiet,
    helmetProps: {
      title: 'Appresso og Arbeiderpartiet',
      description: 'Appresso leverer medlemssystem til Arbeiderpartiet og AUF',
      keywords: 'Arbeiderpartiet,AUF,medlemssystem'
    }
  },
  {
    routeProps: { path: '/arbeid/clooger' },
    Component: Clooger,
    helmetProps: {
      title: 'Appresso - Clooger',
      description: 'Servere og databaser for stor trafikk og avanserte beregninger for kart og geolokasjon',
      keywords: 'Django, API, mobilapp, geolokasjon, GPS'
    }
  },
  {
    routeProps: { path: '/arbeid/vipps' },
    Component: Vipps,
    helmetProps: {
      title: 'Appresso - Vipps',
      description: 'Sammen med Netlife og Scandinavian Design Group har vi levert nettsider til Vipps',
      keywords: 'React, ReactJS, Wagtail, Netlife, Scandinavian Design Group'
    }
  },
  {
    routeProps: { path: '/arbeid/ncl' },
    Component: NCL,
    helmetProps: {
      title: 'Appresso - NCL',
      description: 'Sammen med Behalf har vi levert nettsider til NCL',
      keywords: 'React, GatsbyJS, Netlify, Django, Python, Behalf.no'
    }
  },
  {
    routeProps: { path: '/folka' },
    Component: Employees,
    helmetProps: {
      title: 'Appresso - Ansatte',
      description: 'Våre ansatte er eksperter i Django, Python, Javascript, React, mm.',
      keywords: 'Ansatte, eksperter, django, python, javascript, heroku, react'
    }
  },
  {
    routeProps: { path: '/kontakt' },
    Component: Contact,
    helmetProps: {
      title: 'Appresso - Kontakt',
      description: 'Ta kontakt med Appresso',
      keywords: 'Tor Ivar Johansen, Magne Westlie'
    }
  }
]

export default class App extends Component {
  render () {
    return (
      <BrowserRouter>
        <main>
          <RouteChange />
          <Menu />
          <Container>
            <Switch>
              {routes.map(({ Component, routeProps, helmetProps }) =>
                <Route key={routeProps.path} {...routeProps} render={() => <Component helmetProps={helmetProps} />} />
              )}
            </Switch>
          </Container>
          <Footer />
        </main>
      </BrowserRouter>
    )
  }
}

ReactDOM.render(<App />, document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js